import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, Cpu, Calendar, Star, Mail, BellRing } from "lucide-react";

const STAT_CARDS = [
  { key: "team_members", label: "Team Members", icon: Users, color: "text-voltage-blue" },
  { key: "robots", label: "Robots", icon: Cpu, color: "text-voltage-yellow" },
  { key: "outreach", label: "Outreach Events", icon: Calendar, color: "text-voltage-blue" },
  { key: "sponsors", label: "Sponsors", icon: Star, color: "text-voltage-yellow" },
  { key: "messages", label: "Messages", icon: Mail, color: "text-voltage-blue" },
  { key: "unread_messages", label: "Unread", icon: BellRing, color: "text-red-400" },
];

export default function AdminOverview() {
  const [stats, setStats] = useState({});

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-overview">
      <div className="overline mb-3">// Dashboard</div>
      <h1 className="font-display font-black text-4xl uppercase tracking-tighter mb-10">Overview</h1>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-voltage-blue/30 border border-voltage-blue/30">
        {STAT_CARDS.map((c) => (
          <div
            key={c.key}
            data-testid={`stat-${c.key}`}
            className="bg-voltage-bg p-6 hover:bg-voltage-blue/5 transition-colors"
          >
            <div className="flex items-center justify-between">
              <div className="overline">{c.label}</div>
              <c.icon className={`w-5 h-5 ${c.color}`} />
            </div>
            <div className="font-display font-black text-5xl mt-3 text-white">
              {stats[c.key] ?? "—"}
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 voltage-card p-6">
        <div className="overline mb-2">Quick Tips</div>
        <ul className="text-voltage-muted text-sm space-y-2 font-mono">
          <li>▸ Add team members in <span className="text-voltage-yellow">Team</span></li>
          <li>▸ Showcase robots with photos and specs in <span className="text-voltage-yellow">Robots</span></li>
          <li>▸ Schedule outreach events to fill the public schedule</li>
          <li>▸ Reply to incoming contact form messages</li>
        </ul>
      </div>
    </div>
  );
}
